const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/config/triaplus/setup.ts';
/**
 * Times for schedule "schema"
 */
export const administrationBySchemaTimes = {
    Mo: '7:30',
    Mi: '11:30',
    Ab: '17:30',
    Na: '22:00',
};
